export default class Category {
    constructor(names,type,color) {
        this.names = names;
        this.type = type;
        this.color = color;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; }; }
        if(result) result = this.type && this.color;

        return result;
    }
}